import { axiosApi } from "../lib/axios";
import { apiUrl } from "../environment";
import { toast } from "react-toastify";
import { toast_error,toast_success} from "../config/Constant";
import { decryptData } from "../utils/encryptDecrypt";

let axiosConfig = {
  headers: {
    // 'Authorization': `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  },
};

let axiosConfigFormData = {
  headers: {
    // 'Authorization': `Bearer ${accessToken}`,
    "Content-Type": "multipart/form-data",
  },
};

const API_URL = apiUrl;
//login
export const login = async (payload) => {
  try {
    const response = await axiosApi.post(
      API_URL + "/api/user/login",
      payload,
      axiosConfig
    );
    if (response.data.status) {
      localStorage.setItem("users", JSON.stringify(response.data));

      return response;
    } else {
      return response;
    }
  } catch (e) {
    console.log(e, "responsee");

    return e;
  }
};

export const logOut = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/logout",
      payload,
      axiosConfig
    );
  } catch (e) {
    console.log("axoix service", e);
    return e;
  }
};

export const usersignup = async (fromdata) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/signup",
      fromdata,
      axiosConfig
    );
  } catch (e) {
    console.log("axoix service", e);
    return e;
  }
};

export const sendOtp = async (email) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/sendOtp",
      email,
      axiosConfig
    );
  } catch (e) {
    console.log("axoix service", e);
    return e;
  }
};

export const sendOtpSignUp = async (email) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/sendOtpSignUp",
      email,
      axiosConfig
    );
  } catch (e) {
    console.log("axoix service", e);
    return e;
  }
};

export const verfiyemail = async (input) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/verifyEmail",
      { email: input.email, otp: input.otp },
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkgooglemail = async (chekdata) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/checkEmailGoogle",
      {
        email: chekdata.email,
        social_id: chekdata.social_id,
      },
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
  }
};

export const googleLoginApi = async (access_token) => {
  const result = await axiosApi.get(
    `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${access_token}`,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );
  return result;
};

export const resendOtp = async (input) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/resendOtp",
      input,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkForgotOtp = async (input) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/checkForgotOtp",
      input,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const forgotPassword = async (input) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/forgotPassword",
      input,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const resetPassword = async (input) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/resetPassword",
      input,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const deleteProfileById = async (paylaod) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/deleteProfileById",
      paylaod,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const orderTransaction = async ({ user_id, product_id, total }) => {
  try {
    return await axiosApi.post(
      "commerce/transactions",
      { user_id, product_id, total },
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
  }
};

export const orderHistroy = async (user_id) => {
  try {
    return await axiosApi.post("commerce/oaderDetails", { user_id });
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
  }
};

export const getService = async () => {
  return axiosApi.get("/api/provider/getServiceList", axiosConfig);
};

export const dashboardProjectsData = async (
  startDate,
  endDate,
  timePeriod,
  selectedOption
) => {
  return await axiosApi.post(`/api/provider/dashboardCountsData`, {
    startDate: startDate,
    endDate: endDate,
    timePeriod: timePeriod,
    serviceId: selectedOption,
  });
};

export const joSummeryData = async () => {
  return await axiosApi.post(``);
};

export const dashboardCountData = async (graphDate, graphType) => {
  return await axiosApi.post("/api/provider/dashboardProjectsData", {
    graphDate: graphDate,
    graphType: graphType,
  });
};

export const serviceList = async (keyword, isParent) => {
  return await axiosApi.post("/api/user/serviceSearch", {
    keyword: keyword,
    isParent: isParent,
  });
};

export const childrenServiceList = async (payload) => {
  return await axiosApi.post("/api/user/getChildrenServices", payload);
};

export const filterProvider = async (payload) => {
  const response = await axiosApi.post(
    "/api/user/findProviderByServiceId",
    payload,
    axiosConfig
  );
  const decrypt = await decryptData(response.data.providerData);

  response.data.providerData = decrypt;

  return response;
};

export const getCategoriesList = async (payload) => {
  return await axiosApi.post("/api/user/serviceSearch", payload);
};

export const serviceFilter = async (payload) => {
  return await axiosApi.post("/api/user/serviceFilter", payload);
};

export const recommendedProvider = async (payload) => {
  const response = await axiosApi.post(
    "/api/user/recommendedProviders",
    payload
  );

  const decrypt = decryptData(response.data.providerData);
  response.data.providerData = decrypt;
  return response;
};

export const checkEmail = async (accessToken) => {
  const response = await axiosApi.post(`/api/user/checkEmail`, {
    accessToken,
  });
  return response;
};

export const checkEmailGoogle = async (access_token) => {
  const response = await axiosApi.post(API_URL + `/api/user/checkEmailGoogle`, {
    access_token,
  });
  return response;
};

export const fbLogin = async (payload) => {
  const response = await axiosApi.post(
    `/api/user/fbLogin`,
    payload,
    axiosConfig
  );
  return response;
};

export const GoogleLoginCheck = async (payload) => {
  const response = await axiosApi.post(
    `/api/user/googleLogin`,
    payload,
    axiosConfig
  );
  return response;
};

export const ChangePassword = async (payload) => {
  try {
    const response = await axiosApi.post(
      `/api/provider/changePassword`,
      payload
    );
    return response;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

//****************provider api***************************************************************************

export const provider_getProfile = async (callback) => {
  try {
    const response = await axiosApi.get(`${API_URL}/api/provider/getProfile`, axiosConfig);
    const { provider, bankDetails } = response.data;

    // Decrypt provider data
    response.data.provider = await decryptData(provider);

    // Decrypt account number if it exists
    if (bankDetails?.accountNumber) {
      bankDetails.accountNumber = await decryptData(bankDetails.accountNumber);
    }

    return response;
  } catch (e) {
    toast.error(e.response?.data?.message || "Failed to fetch profile", toast_error);
    return e;
  }
};

export const findUserById = async (payload) => {
  try {
    let response = await axiosApi.post(
      API_URL + "/api/user/findById",
      payload,
      axiosConfig
    );

    let decrypt = decryptData(response.data);
    response.data = decrypt;
    return response;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const updateAvailability = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/updateAvailability",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
  }
};

export const updateProfile = async (providerData) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/updateProfile",
      providerData,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
  }
};

export const fetchJobs = async (payload) => {
  try {
    let response = await axiosApi.post(
      API_URL + "/api/provider/myJobsList",
      payload,
      axiosConfig
    );

    let decrypt = await decryptData(response.data.jobs);
    response.data.jobs = decrypt;
    return response;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchUserJobs = async (payload) => {
  try {
    let response = await axiosApi.post(
      API_URL + "/api/user/myJobsList",
      payload,
      axiosConfig
    );
    let decrypt = decryptData(response.data.jobs);
    response.data.jobs = decrypt;
    return response;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchAllJobs = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/allJobsList",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchIncomingJobs = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/jobRequestList",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchUserIncomingJobs = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/jobRequestList",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const approveRejectJob = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/changeJobStatus",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const approveRejectQuote = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/updateQuoteStatus",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const cancelUserJob = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/cancelJob",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchJobDetails = async (payload) => {
  try {
    let responce = await axiosApi.post(
      API_URL + "/api/provider/findJobById",
      payload,
      axiosConfig
    );

    let decrypt = decryptData(responce.data.jobData);
    responce.data.jobData = decrypt;
    return responce;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchUserJobListByReqType = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/jobsList",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const calculateTax = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/calculateTaxAmount",
      payload,
      axiosConfig
    );
  } catch (e) {
    // toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const calculateTaxByAmount = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/calculateTaxByAmount",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const markJobComplete = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/update",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkProviderStartJob = async (jobId) => {
  try {
    const response = await axiosApi.post(
      API_URL + "/api/job/checkProviderStartJob",
      { jobId },
      axiosConfig
    );
    return response.data;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return null; // Handle error appropriately
  }
};

export const createDispute = async (fromdata) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/admin-user/createDispute",
      fromdata,
      axiosConfigFormData
    );
  } catch (e) {
    console.log("axoix service", e);
    return e;
  }
};

export const shareReQuote = async (fromdata) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/quoteFileUpload",
      fromdata,
      axiosConfigFormData
    );
  } catch (e) {
    console.log("axoix service", e);
    return e;
  }
};

export const updateDeliveryStatus = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/updateTrackingStatus",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const verifyJobOtp = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/matchOtp",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const markCompleteJob = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/markCompleteJob",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateProviderStartJob = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/updateProviderStartJob",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return null; // Handle error appropriately
  }
};

export const getJobQuoteStatusById = async (payload) => {
  try {
    const response = await axiosApi.post(
      API_URL + "/api/job/getJobQuoteStatusById",
      payload,
      axiosConfig
    );
    return response.data; // Ensure you return the data property
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return null; // Return null or handle it as per your requirements
  }
};

export const uploadSelfie = async (fromdata) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/uploadSelfie",
      fromdata,
      axiosConfigFormData
    );
  } catch (e) {
    console.log("axoix service", e);
    return e;
  }
};

export const createJobReview = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/saveRating",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const getProviderListByServiceId = async (payload) => {
  try {
    const response = await axiosApi.post(
      API_URL + "/api/user/findProviderByServiceId",
      payload,
      axiosConfig
    );

    const decrypt = await decryptData(response.data.providerData);

    response.data.providerData = decrypt;

    return response;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchProviderServiceList = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/getProviderServicesList",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchProviderRatingDetail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/getProviderRatingDetail",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchProviderServiceDetail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/service/findByProvider",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchProviderRating = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/getRatingsList",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchUserRating = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/getRatingsList",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchProviderAvailability = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/providerAvailability",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const createJob = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/create",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchSavedAddress = async (payload) => {
  try {
    return await axiosApi.get(
      API_URL + `/api/user/findSavedAddress?type=${payload}`,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const findNonTruckingSavedAddress = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/user/findNonTruckingSavedAddress`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchSubscriptionPlans = async () => {
  try {
    return await axiosApi.get(
      API_URL + `/api/provider/getPlanList`,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const applyPromoCode = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/purchaseSubscription`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkPromoCode = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/checkPromoCode`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchTransactionDetails = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/transaction/findAllTransaction`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const giveTip = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/giveTip",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const getAllContent = async () => {
  try {
    return await axiosApi.get(
      API_URL + "/api/admin-user/getAllContent",
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const getContent = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/admin-user/getContentById",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchNotification = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/notification/listWithPagination`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchLiveLocation = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/user/getLiveLocation`,
      payload,
      axiosConfig
    );
  } catch (e) {
    return e;
  }
};

export const updateProfile_customer = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/user/updateProfile`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateNotificationSettings = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/updateNotificationSettings`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const deleteService = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/admin-provider/deleteService`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateAvailabilityTiming = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/updateShiftTiming`,
      { shifts: payload },
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateNotificationSettingsProvider = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/updateNotificationSettings`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateJobBufferSettings = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/updateJobBufferSettings`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const sendReferralEmail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/sendReferralEmail`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const saveGoogleAccessToken = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/saveGoogleToken`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const saveOutlookAccessToken = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/saveOutlookToken`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchProviderRevenueData = async () => {
  try {
    return await axiosApi.post(API_URL + `/api/provider/transactionCountsData`);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchUserRevenueData = async () => {
  try {
    return await axiosApi.post(API_URL + `/api/user/userTransactionCountsData`);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const serviceSummery = async () => {
  try {
    return await axiosApi.post(API_URL + `/api/provider/serviceSummery`);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const completedServicesSummery = async () => {
  try {
    return await axiosApi.post(API_URL + `/api/provider/completedServicesById`);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const roleSwich = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/user/switchUserType`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

//Api call for fetching customer authorize profile
export const fetchAuthorizeCustomerProfile = async (payload) => {
  try {
    return await axiosApi.post(
      "/api/paymentGateway/getCustomerProfile",
      payload
    );
  } catch (error) {
    console.log(error);
  }
};

//Api call for  add card authorize profile
export const addCard = async (payload) => {
  try {
    return await axiosApi.post(
      "/api/paymentGateway/createCustomerPaymentProfile",
      payload
    );
  } catch (error) {
    console.log(error);
  }
};

//Api call for  delete card authorize profile
export const deleteCard = async (payload) => {
  try {
    return await axiosApi.post(
      "/api/paymentGateway/deleteCustomerPaymentProfile",
      payload
    );
  } catch (error) {
    console.log(error);
  }
};

//Api call for  delete card authorize profile
export const fetchTipPlatformFee = async (payload) => {
  try {
    return await axiosApi.get("/api/user/getTipPlatformFee");
  } catch (error) {
    console.log(error);
  }
};

//Api call for  send job payment
export const sendJobPayment = async (payload) => {
  try {
    return await axiosApi.post("/api/paymentGateway/sendJobPayment", payload);
  } catch (error) {
    console.log(error);
  }
};

//Api call for  get bank status
export const fetchBankDetailsStatus = async () => {
  try {
    return await axiosApi.get("/api/provider/getBankDetails");
  } catch (error) {
    console.log(error);
  }
};

//Api call for generating job invoice
export const fetchProviderJobInvoice = async (payload) => {
  try {
    return await axiosApi.post("/api/job/generateJobInvoice", payload);
  } catch (error) {
    console.log(error);
  }
};

export const setPrimaryPaymentProfile = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/paymentGateway/setPrimaryPaymentProfile`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const addAccountDetail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/addBankDetail`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateAccountDetail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/updateBankDetail`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkDoucument = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/user/checkDocument`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const changeJobStartTime = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/changeJobTime`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const serviceImageUpload = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/serviceImageUpload`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const serviceImageRemove = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/serviceImageRemove`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchMarketingSubsPlans = async () => {
  try {
    return await axiosApi.get(
      API_URL + `/api/provider/getMarketingPlanList`,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkMarketingPromoCode = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/checkMarketingPlanPromoCode`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const applyMarketingPromoCode = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/purchaseMarketingSubscription`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const sendMarketingJobEmail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/sendMarketingJobEmail",
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const getServiceListForUser = async () => {
  return axiosApi.get("/api/provider/getServiceListForUser", axiosConfig);
};

export const UpdateMarketingEmail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/updateMarketingEmail",
      payload,
      axiosConfig
    );
  } catch (e) {
    return e;
  }
};

export const shareFinalQuote = async (fromdata) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/finalQuoteFileUpload",
      fromdata,
      axiosConfigFormData
    );
  } catch (e) {
    console.log("axoix service", e);
    return e;
  }
};

export const fetchJobsCount = async (payload) => {
  try {
    return await axiosApi.get(API_URL + "/api/provider/jobRequestCount");
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const giveSuggestion = async (description, email) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/reportBug",
      { description: description, email: email },
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const getJobMarksByUserId = async (userId) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/job/userJobMarksCount`,
      { userId: userId },
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateJobStatusByUser = async (payload) => {
  try {
    return await axiosApi.put(
      API_URL + `/api/job/updateJobStatusByUser`,
      payload,
      axiosConfig
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};


export const verifyCoupons = async (payload) => {
  try {
    const response = await axiosApi.post(
      API_URL + `/api/coupon/verifyCoupons`,
      payload,
      axiosConfig
    );

    toast.success(response?.data?.message || "Coupon verified successfully!", toast_success); 
    return response;

  } catch (e) {
    toast.error(e.response?.data?.message || "Something went wrong!", toast_error);
    return e;
  }
};
